export enum QueueStatusType {
    AllQueues,
    MyQueues
}